import {
  ContentSource,
  TestableWord
} from "seneca-common/features/module/module-types/worked-example/types";

export const canBeTested = (contentSource: ContentSource): boolean => {
  return contentSource.steps
    .map(step => step.equation)
    .some(eq => {
      return eq.some(elem => {
        return (elem as TestableWord).word ? true : false;
      });
    });
};
